import React, { useState, useRef, useEffect } from 'react';
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Font, Svg, Line, Rect   } from '@react-pdf/renderer';
import ReactPDF from '@react-pdf/renderer';
import '../shared/fonts';

const styles = StyleSheet.create({
  page: {
    fontFamily:"iransans",
    flexDirection: 'row',
    backgroundColor: '#ffffff'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomWidth: 1,
    borderRightWidth: 1,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
  
});

export default function  PrintGradeSheet(props){
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const margin = 25;
  const rowIndexColWidth = 30;
  const courseColWidth = 210;
  const monthColWidth = 40;
  const gradeColWidth = 80;
  const mainRowHeight = 60;
  const dataRowHeight = 28;
  const textFontSize = 8;
  const numFontSize = 9;
  const gradeSheets = props.data;
  const pdfSize = [2*gradeColWidth+10*monthColWidth+courseColWidth+rowIndexColWidth+2*margin, 3*mainRowHeight + 18*dataRowHeight+ 3 * 20 + 2 * 230 + 4 * dataRowHeight + 2 * margin];
  const chartBarDistance = 30;
  const headerRow = [
    {title:"درجه", width:monthColWidth, left:0, monthInd:-1},
    {title:"رتبه در پایه", width:gradeColWidth, left:monthColWidth, monthInd:-1},
    {title:"رتبه در کلاس", width:gradeColWidth, left:1*gradeColWidth+1*monthColWidth, monthInd:-1},
    {title:"میانگین", width:monthColWidth, left:2*gradeColWidth+1*monthColWidth, monthInd:-1},
    {title:"اردیبهشت", width:monthColWidth, left:2*gradeColWidth+2*monthColWidth, monthInd:1},
    {title:"فروردین", width:monthColWidth, left:2*gradeColWidth+3*monthColWidth, monthInd:0},
    {title:"اسفند", width:monthColWidth, left:2*gradeColWidth+4*monthColWidth, monthInd:11},
    {title:"بهمن", width:monthColWidth, left:2*gradeColWidth+5*monthColWidth, monthInd:10},
    {title:"دی", width:monthColWidth, left:2*gradeColWidth+6*monthColWidth, monthInd:9},
    {title:"آذر", width:monthColWidth, left:2*gradeColWidth+7*monthColWidth, monthInd:8},
    {title:"آبان", width:monthColWidth, left:2*gradeColWidth+8*monthColWidth, monthInd:7},
    {title:"مهر", width:monthColWidth, left:2*gradeColWidth+9*monthColWidth, monthInd:6},
    {title:"نام درس", width:courseColWidth, left:2*gradeColWidth+10*monthColWidth, monthInd:-1},
    {title:"#", width:rowIndexColWidth, left:2*gradeColWidth+10*monthColWidth+courseColWidth, monthInd:-1},
  ];
  const setEmptyRows = function(){
    var max = 18;
    for(var i=0;i<gradeSheets.length;i++){
      gradeSheets[i]["emptyRows"] = [];
      console.log("(i, len)->" + "(" + i + ", " + gradeSheets[i].courses.length + ")");
      if(gradeSheets[i].courses.length < max) {
        var rem = max-gradeSheets[i].courses.length;
        console.log("(i, rem)->" + "(" + i + ", " + rem + ")");
        gradeSheets[i]["emptyRows"] = Array.from({length:(rem)});
      }
    }
    return max;
  }
  
  const getProgressChartData = function(gs){
    var res = [];
    for(var i=7;i<=12;i++){
      if(gs.monthStates[i-1].isValid){
        res.push({
          month:util.getMonthName(gs.monthStates[i-1].monthNo),
          average:gs.monthStates[i-1].result.average,
        });
      }
    }
    for(var i=1;i<=6;i++){
      if(gs.monthStates[i-1].isValid){
        res.push({
          month:util.getMonthName(gs.monthStates[i-1].monthNo),
          average:gs.monthStates[i-1].result.average,
        });
      }
    }
    return res;
  }
  

  useEffect(() => {
     
  }, []);
  const getScore = function(gs, score){
    var deg = gs.schoolClass.degree;
    return util.getScore(deg, score);
  }
  return(
    <Document key={"doc_"}>
      {
        gradeSheets.map((gs, pageIndex)=>{
          return(
            <Page size={pdfSize} style={styles.page} key={"page_" + gs.id}>
              <View style={{position:"absolute", width:pdfSize[0]-2*margin, height:mainRowHeight*3, left:margin, top:margin}}>
                <View style={{position:"absolute", fontFamily:"iransans", top:0, left:0, width:monthColWidth+gradeColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:20}}>{gs.result.grade}</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight, left:0, width:monthColWidth+gradeColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>معدل کل کلاس</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>{getScore(gs, gs.result.classAverage)}</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight*2, left:0, width:monthColWidth+gradeColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center", paddingRight:"3px"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>معدل کل پایه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>{getScore(gs, gs.result.schoolAverage)}</Text>
                </View>

                <View style={{position:"absolute", backgroundColor:"#e2fad4ff", top:0, left:monthColWidth+gradeColWidth, width:monthColWidth+gradeColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center"}}>معدل</Text>
                </View>
                <View style={{position:"absolute", backgroundColor:"#e2fad4ff", top:mainRowHeight, left:monthColWidth+gradeColWidth, width:monthColWidth+gradeColWidth, height:mainRowHeight*2, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center"}}>{ getScore(gs, gs.result.average)}</Text>
                </View>

                <View style={{position:"absolute", top:0, left:(monthColWidth+gradeColWidth)*2, width:monthColWidth*2, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center"}}>انضباط</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight, left:(monthColWidth+gradeColWidth)*2, width:monthColWidth*2, height:mainRowHeight*2, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center"}}>{ getScore(gs, gs.disiplineScore)}</Text>
                </View>

                <View style={{position:"absolute", top:0, left:monthColWidth*4+gradeColWidth*2, width:monthColWidth*2, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>رتبه در کلاس</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>{util.toPersianDigits(gs.result.levelInClass)}</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight, left:monthColWidth*4+gradeColWidth*2, width:monthColWidth*2, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>رتبه در مدرسه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>{util.toPersianDigits(gs.result.levelInSchool)}</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight*2, left:monthColWidth*4+gradeColWidth*2, width:monthColWidth*2, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "flex-end", paddingRight:"3px"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>کلاس</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>{util.toPersianDigits(gs.schoolClass.name)}</Text>
                </View>

                <View style={{position:"absolute", top:0, left:monthColWidth*6+gradeColWidth*2, width:monthColWidth*4, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "flex-end", paddingRight:"3px"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>نام و نام خانوادگی</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", direction:"rtl"}}>{gs.student.firstname + " " + gs.student.lastname}</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight, left:monthColWidth*6+gradeColWidth*2, width:monthColWidth*4, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "flex-end", paddingRight:"3px"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>نام ولی</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", direction:"rtl"}}>{gs.student.parent == null? "": (gs.student.parent.firstname + " " + gs.student.parent.lastname)}</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight*2, left:monthColWidth*6+gradeColWidth*2, width:monthColWidth*4, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "flex-end", paddingRight:"3px"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>رشته-پایه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"10", direction:"rtl"}}>{util.toPersianDigits(gs.schoolClass.field.title + " - " + util.getDegreeChar(gs.schoolClass.degree))}</Text>
                </View>

                <View style={{position:"absolute", top:0, left:monthColWidth*10+gradeColWidth*2, width:courseColWidth + rowIndexColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", fontWeight:"bold", direction:"rtl"}}>کارنامه ماهانه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", fontWeight:"bold", direction:"rtl"}}>عملکرد تحصیلی</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight, left:monthColWidth*10+gradeColWidth*2, width:courseColWidth + rowIndexColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "flex-end", paddingRight:"3px"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}>مدرسه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"11", direction:"rtl"}}>{util.toPersianDigits(util.getSchoolName())}</Text>
                </View>
                <View style={{position:"absolute", top:mainRowHeight*2, left:monthColWidth*10+gradeColWidth*2, width:courseColWidth + rowIndexColWidth, height:mainRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "flex-end", paddingRight:"3px"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"9", direction:"rtl"}}>سال تحصیلی</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9", direction:"rtl"}}> </Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:"10", direction:"rtl"}}>{util.getEducationName()}</Text>
                </View>

              </View>
              <View style={{position:"absolute", backgroundColor:"#444644ff", width:pdfSize[0]-2*margin, height:dataRowHeight, left:margin, top:margin+3*mainRowHeight}}>
                {
                  headerRow.map((col, colindex)=>{
                    return(
                      <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                        <Text style={{position:"relative", textAlign:"center", fontSize:"9", color:"#FFF"}}>{col.title}</Text>
                      </View>

                    )
                  })
                }
              </View>
              {
                gs.courses.map((course, courseInd)=>{
                  return(
                    <View style={{position:"absolute", backgroundColor:(courseInd%2 == 0?"#fff" : "#f6f6f6"), width:pdfSize[0]-2*margin, height:dataRowHeight, left:margin, top:((courseInd+1)*dataRowHeight) +(margin+3*mainRowHeight)}}>
                      {
                        headerRow.map((col, colindex)=>{
                          return(
                            <>
                            {
                            colindex==0?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{course.result.grade}</Text>
                            </View>
                            :
                            colindex==1?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{util.toPersianDigits(course.result.levelInSchool)}</Text>
                            </View>
                            :
                            colindex==2?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{util.toPersianDigits(course.result.levelInClass)}</Text>
                            </View>
                            :
                            colindex==3?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{getScore(gs, course.result.average)}</Text>
                            </View>
                            :
                            colindex==12?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{course.course.name}</Text>
                            </View>
                            :
                            colindex==13?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{util.toPersianDigits(courseInd+1)}</Text>
                            </View>
                            :
                            <>
                            {
                              course.scores[col.monthInd].isValid?
                              <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                                <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{getScore(gs, course.scores[col.monthInd].score)}</Text>
                              </View>
                              :
                              <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                                <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{""}</Text>
                              </View>
                              

                            }
                            </>
                            }
                            </>
                          )
                        })
                      }
                    </View>
                  )
                })
              }
              {
                    <View style={{position:"absolute", backgroundColor:"#d6d6d6", width:pdfSize[0]-2*margin, height:dataRowHeight, left:margin, top:((gs.courses.length +1)*dataRowHeight) +(margin+3*mainRowHeight)}}>
                      {
                        headerRow.map((col, colindex)=>{
                          return(
                            <>
                            {
                            colindex==0?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}></Text>
                            </View>
                            :
                            colindex==1?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}></Text>
                            </View>
                            :
                            colindex==2?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}></Text>
                            </View>
                            :
                            colindex==3?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}></Text>
                            </View>
                            :
                            colindex==12?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>معدل</Text>
                            </View>
                            :
                            colindex==13?
                            <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                              <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}></Text>
                            </View>
                            :
                            <>
                            {
                              gs.monthStates[col.monthInd].isValid?
                              <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                                <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{getScore(gs, gs.monthStates[col.monthInd].result.average)}</Text>
                              </View>
                              :
                              <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                                <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{""}</Text>
                              </View>
                              

                            }
                            </>
                            }
                            </>
                          )
                        })
                      }
                    </View>

              }
              {
                gs.emptyRows.map((r, emptyInd)=>{
                  return(
                    <View style={{position:"absolute", width:pdfSize[0]-2*margin, height:dataRowHeight, left:margin, top:((gs.courses.length + emptyInd+2)*dataRowHeight) +(margin+3*mainRowHeight)}}>
                        {
                          headerRow.map((col, colindex)=>{
                            return(
                              <View style={{position:"absolute", top:0, left:col.left, width:col.width, height:dataRowHeight, border:"1px solid #000", justifyContent:"center",alignItems: "center"}}>
                                <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}></Text>
                              </View>

                            )
                          })
                        }
                    </View>
                  )
                })
              }
              <View style={{position:"absolute", borderTop:"2px dashed #888", width:pdfSize[0]-2*margin, height:dataRowHeight*2, left:margin, top:pdfSize[1]-margin-dataRowHeight*3}}>
                <View style={{position:"absolute", top:0, right:margin, width:200, height:dataRowHeight, justifyContent:"flex-start",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>مدیر آموزشگاه</Text>
                  <Text style={{position:"relative", textAlign:"center", fontSize:"9"}}>{gs.manager.firstname + " " + gs.manager.lastname}</Text>
                </View>
              </View>

              <View style={{position:"absolute", overflow:"hidden", border:"1px dotted #888", paddingTop:15, width:pdfSize[0]-2*margin, height:230, left:margin, top:margin + 10 + 3 * mainRowHeight + 20 * dataRowHeight}}>
                <Svg height="200" width={pdfSize[0]-(2*margin)}>
                  {/* خط افقی */}
                  <Line x1="50" y1="160" x2={chartBarDistance * gs.courses.length + 150} y2="160" stroke="black" strokeWidth={2} />
                  <Rect x={28} y={60} width={16} height={4} strokeWidth={0} fill="rgba(223, 128, 247, 1)" />
                  <Rect x={23} y={90} width={24} height={8} strokeWidth={0} fill="rgba(189, 224, 248, 1)" />
                  {
                    gs.courses.map((course, courseInd)=>{
                      return(
                        <>
                          <Line x1={100 + (courseInd*chartBarDistance)} y1="0" x2={100 + (courseInd*chartBarDistance)} y2="160" stroke="#b0b0b0" strokeWidth={8} />
                          <Rect x={100 + (courseInd*chartBarDistance)-12} y={160 - (8 * course.result.schoolAverage - 4)} width={24} height={8} strokeWidth={0} fill="rgba(189, 224, 248, 1)" />
                          <Rect x={100 + (courseInd*chartBarDistance)-8} y={160 - (8 * course.result.average - 2)} width={16} height={4} strokeWidth={0} fill="rgba(223, 128, 247, 1)" />
                          {
                            courseInd>0?
                            <Line x1={100 + (courseInd*chartBarDistance)-8} y1={160 - (8 * course.result.average) + 4}
                            x2={100 + ((courseInd-1)*chartBarDistance)+8} y2={160 - (8 * gs.courses[courseInd-1].result.average) + 4} stroke="rgba(223, 128, 247, 1)" strokeWidth={1} />
                            :<></>
                          }
                        </>
                      )
                    })
                  }
                </Svg>
                <View style={{position:"absolute", fontFamily:"iransans", top:75, left:0, width:70, height:25, justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:6}}>میانگین دانش آموز</Text>
                </View>
                <View style={{position:"absolute", fontFamily:"iransans", top:105, left:0, width:70, height:25, justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:6}}>میانگین پایه</Text>
                </View>
                <View style={{position:"absolute", backgroundColor:"#f8f1dcff", fontFamily:"iransans", border:"1px dotted #888", top:20, right:20, width:200, height:60, justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:9}}>نمودار مقایسه میانگین نمرات دانش آموز</Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:9}}>با میانگین نمرات کل پایه</Text>
                  <Text style={{position:"relative", textAlign:"right", fontSize:9}}>در همه دروس</Text>
                </View>
                {
                  gs.courses.map((course, courseInd)=>{
                    return(
                      <>
                        <View style={{position:"absolute", fontFamily:"iransans", top:210, left:(-2+(courseInd*chartBarDistance)), transform:"rotate(-45deg)", width:120, height:25, justifyContent:"center",alignItems: "flrx-start"}}>
                          <Text style={{position:"relative", textAlign:"right", fontSize:8}}>{course.course.name}</Text>
                        </View>
                        <View style={{position:"absolute", fontFamily:"iransans", top:(160 - (8 * course.result.average) + 2), left:(85 + (courseInd*chartBarDistance)), width:30, height:25, justifyContent:"center",alignItems: "center"}}>
                          <Text style={{position:"relative", textAlign:"right", fontSize:6, color:"#000000"}}>{util.toPersianDigits(course.result.average)}</Text>
                        </View>
                        
                      </>
                    )
                  })
                }
              </View>

              <View style={{position:"absolute", overflow:"hidden", border:"1px dotted #888", paddingTop:15, width:pdfSize[0]-2*margin, height:230, left:margin, top:margin + 10 + 3 * mainRowHeight + 20 * dataRowHeight + 240}}>
                <Svg height="200" width={pdfSize[0]-(2*margin)}>
                  {/* خط افقی */}
                  <Line x1="50" y1="160" x2={chartBarDistance * getProgressChartData(gs).length + 150} y2="160" stroke="black" strokeWidth={2} />
                  {
                    getProgressChartData(gs).map((month, monthInd)=>{
                      return(
                        <>
                          <Line x1={100 + (monthInd*chartBarDistance)} y1="0" x2={100 + (monthInd*chartBarDistance)} y2="160" stroke="#b0b0b0" strokeWidth={8} />
                          <Rect x={100 + (monthInd*chartBarDistance)-8} y={160 - (8 * month.average - 2)} width={16} height={4} strokeWidth={0} fill="rgba(223, 128, 247, 1)" />
                          {
                            monthInd>0?
                            <Line x1={100 + (monthInd*chartBarDistance)-8} y1={160 - (8 * month.average) + 4}
                            x2={100 + ((monthInd-1)*chartBarDistance)+8} y2={160 - (8 * getProgressChartData(gs)[monthInd-1].average) + 4} stroke="rgba(223, 128, 247, 1)" strokeWidth={1} />
                            :<></>
                          }
                        </>
                      )
                    })
                  }
                </Svg>
                <View style={{position:"absolute", backgroundColor:"#f8f1dcff", fontFamily:"iransans", border:"1px dotted #888", top:20, right:20, width:200, height:60, justifyContent:"center",alignItems: "center"}}>
                  <Text style={{position:"relative", textAlign:"right", fontSize:9}}>نمودار پیشرفت تحصیلی ماهانه دانش آموز</Text>
                </View>
                {
                  getProgressChartData(gs).map((month, monthInd)=>{
                    return(
                      <>
                        <View style={{position:"absolute", fontFamily:"iransans", top:210, left:(-2+(monthInd*chartBarDistance)), transform:"rotate(-45deg)", width:120, height:25, justifyContent:"center",alignItems: "flrx-start"}}>
                          <Text style={{position:"relative", textAlign:"right", fontSize:8}}>{month.month}</Text>
                        </View>
                        <View style={{position:"absolute", fontFamily:"iransans", top:(160 - (8 * month.average) + 2), left:(85 + (monthInd*chartBarDistance)), width:30, height:25, justifyContent:"center",alignItems: "center"}}>
                          <Text style={{position:"relative", textAlign:"right", fontSize:6}}>{util.toPersianDigits(month.average)}</Text>
                        </View>
                        
                      </>
                    )
                  })
                }
              </View>
            </Page>
          )
        })
      }
    </Document>  
  )
}
